import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SessionType, getBaseUrl } from '@shared';
import { selectSession } from '@client/model';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';

export function AuthSignout() {
  const { logout, user, isAuthenticated } = useAuth0();
  const session = useSelector(selectSession);
  const isClient = session.sessionType === SessionType.client;
  const { isClerkSignedIn, clerkSignOut } = useClerkClientAuth();

  useEffect(() => {
    // Only use Clerk signout for Clerk-only users (not advisors who happen to have a Clerk cookie)
    if (isClerkSignedIn && !isAuthenticated) {
      clerkSignOut({ redirectUrl: '/client/login' });
      return;
    }

    logout({
      logoutParams: {
        returnTo: isClient
          ? `${getBaseUrl()}/client/login`
          : `${getBaseUrl()}?email_hint=${encodeURIComponent(user?.email ?? '')}`,
      },
    });
  }, []);

  return null;
}
